/**
 * Radix focuses the first tabbable thing, which is usually a text field - and that opens the
 * on-screen keyboard over the form the beheerder was about to read. Focus still moves into the
 * panel, so it is announced and tabbing starts inside it; only the caret is withheld.
 */
export function focusPanelNotItsFields(event: Event) {
  event.preventDefault();
  (event.target as HTMLElement | null)?.focus();
}
